import { createAsyncThunk } from '@reduxjs/toolkit';

import { handleRequestError } from 'helpers/network';
import type { RootState } from 'old-store/store';
import {
  checkIfAuthorizedAndLogoutIfNot,
  ISelectionSaveValues,
  persistSelection
} from 'store/slices/selection/actions';

export const saveSelection = createAsyncThunk<
  any,
  ISelectionSaveValues,
  { state: RootState; rejectValue: string }
>(
  'scrAppBook/selectionWorkflow/saveSelection',
  async (values, { getState, dispatch, rejectWithValue }) => {
    try {
      const state = getState();
      const currentSelection = await persistSelection({
        values,
        state,
        dispatch,
        predefinedSelectionId: state.modals.sendSelectionModal.selectionId,
        updateSelectionState: state.selection.updateSelectionState
      });

      return {
        currentSelection,
        withCongratsModal: values.withCongratsModal,
        withPasswordModal: values.withPasswordModal,
        successMessageKey: values.successMessageKey
      };
    } catch (error: any) {
      const requestError = handleRequestError(error);

      checkIfAuthorizedAndLogoutIfNot(requestError.code);

      return rejectWithValue(requestError.message);
    }
  }
);
